import FacebookResource from '@/resources/FacebookResource';

export default class Facebook {
    constructor() {
        this.Resource = new FacebookResource()
    }

    async connect (websiteId, accessToken, pixelId, eventName) {
        return await this.Resource.connect(websiteId, accessToken, pixelId, eventName)
    }
}